import { bookingAPI, eventBookingAPI } from './api';

/**
 * Get all booked dates for a specific room
 * @param {number} roomId - The room ID (optional, can be room name like "Room 1")
 * @returns {Promise<Date[]>} Array of booked dates
 */
export const getBookedDatesForRoom = async (roomIdentifier) => {
  try {
    if (!roomIdentifier) return [];
    
    // Fetch all bookings
    const response = await bookingAPI.getAll({ per_page: 10000 });
    const bookings = response.data.data?.data || response.data.data || [];
    
    // Filter bookings for this room and extract dates
    const bookedDates = [];
    bookings.forEach(booking => {
      // Match by service_type (e.g., "Room 1 - Executive Deluxe")
      if (booking.service_type && booking.service_type.includes(roomIdentifier)) {
        const bookingDate = new Date(booking.booking_date);
        bookedDates.push(bookingDate);
      }
    });
    
    return bookedDates;
  } catch (error) {
    console.error('Error fetching booked dates:', error);
    return [];
  }
};

/**
 * Get all booked dates for event bookings
 * @returns {Promise<Date[]>} Array of booked event dates
 */
export const getBookedEventDates = async () => {
  try {
    // Fetch booked dates from the public endpoint
    const response = await eventBookingAPI.getBookedDates();
    const bookedDateStrings = response.data.data || [];
    
    // Convert strings to Date objects
    const bookedDates = bookedDateStrings.map(dateStr => new Date(dateStr));
    
    return bookedDates;
  } catch (error) {
    console.error('Error fetching booked event dates:', error);
    return [];
  }
};

/**
 * Check if a date is booked
 * @param {Date} dateToCheck - The date to check
 * @param {Date[]} bookedDates - Array of booked dates
 * @returns {boolean} True if the date is booked
 */
export const isDateBooked = (dateToCheck, bookedDates) => {
  if (!dateToCheck || !bookedDates.length) return false;
  
  return bookedDates.some(bookedDate => {
    return (
      dateToCheck.getFullYear() === bookedDate.getFullYear() &&
      dateToCheck.getMonth() === bookedDate.getMonth() &&
      dateToCheck.getDate() === bookedDate.getDate()
    );
  });
};
